// Injection key for the quote action channel.
//
// QuoteActionMenu sits three levels below QuoteGroupsList
// (QuoteGroupsList > QuoteGroup > QuoteCard > QuoteActionMenu) and has no
// interest in the two components between them, so its actions used to travel
// on the global EventBus instead of being relayed up through props.
//
// A global bus has no notion of which list a click belongs to: every mounted
// QuoteGroupsList received every emit and re-emitted it to its own parent. One
// click on Archive then fired one request per mounted list. That is invisible
// while a single list is mounted. Until TB-2216 restored the turbo:before-render
// teardown in lib/turbo.js, Turbo navigation left earlier Vue apps mounted but
// detached (ENG-260), so the count grew with the session and one click ended up
// archiving, cloning or emailing N times (TOF-696). TB-2216 removed that route
// to a second mounted list; this channel makes any second mount harmless.
//
// Provide/inject carries the same "skip the middle components" convenience but
// resolves through the component tree, so a menu can only ever reach the list
// it actually sits inside, however many lists are mounted.
//
// Deliberately a plain string rather than a Symbol: the provider and the
// consumer import this module through different aliases ("serviceshift-ui/..."
// and a relative path). If a bundler ever gives those two specifiers separate
// module instances, a Symbol would produce two distinct keys and inject would
// silently fall back to a no-op, whereas a string keeps matching by value.
export const QUOTE_ACTION_DISPATCH = "quoteActionDispatch";
